<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
          label="KEY">
          {{model.id}}
        </a-form-model-item>
        <a-form-model-item
          prop="name"
          label="名称">
          <a-input placeholder="请输入名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
          prop="appId"
          label="appId">
          <a-input placeholder="请输入appId" v-model="model.appId" />
        </a-form-model-item>
        <a-form-model-item
            prop="appSecret"
          label="appSecret">
          <a-input placeholder="请输入appSecret" v-model="model.appSecret" />
        </a-form-model-item>
        <a-form-model-item
            prop="token"
          label="token">
          <a-input placeholder="请输入token" v-model="model.token" />
        </a-form-model-item>
        <a-form-model-item
            prop="pageUrl"
          label="微信跳转页面">
          <a-textarea :rows="2" placeholder="请输入微信跳转页面" v-model="model.pageUrl" />
        </a-form-model-item>
        <a-form-model-item
            prop="templateId"
          label="微信消息模版ID">
          <a-input placeholder="请输入微信消息模版ID" v-model="model.templateId" />
        </a-form-model-item>
        <a-form-model-item
            prop="title"
          label="title消息">
          <a-input placeholder="请输入title消息" v-model="model.title" />
        </a-form-model-item>
        <a-form-model-item
            prop="titleKw"
          label="title的keyword">
          <a-input placeholder="请输入title的keyword" v-model="model.titleKw" />
        </a-form-model-item>
        <a-form-model-item
            prop="remark"
          label="消息体">
          <a-textarea :rows="2" placeholder="请输入消息体" v-model="model.remark" />
        </a-form-model-item>
        <a-form-model-item
            prop="remarkKw"
          label="消息体keyword">
          <a-input placeholder="请输入消息体keyword" v-model="model.remarkKw" />
        </a-form-model-item>
        <!--<a-form-model-item-->
            <!--prop="remarkColor"-->
          <!--label="消息体的颜色">-->
          <!--<a-input placeholder="请输入消息体的颜色" v-model="model.remarkColor" />-->
        <!--</a-form-model-item>-->
        <a-form-model-item
            prop="nameKw"
          label="姓名keyword">
          <a-input placeholder="请输入姓名keyword" v-model="model.nameKw" />
        </a-form-model-item>
        <a-form-model-item
            prop="periodDateKw"
          label="随访时间keyword">
          <a-input placeholder="请输入随访时间keyword" v-model="model.periodDateKw" />
        </a-form-model-item>
        <a-form-model-item
            prop="periodFormKw"
          label="随访内容keyword">
          <a-input placeholder="请输入随访内容keyword" v-model="model.periodFormKw" />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "WechatConfigModal",
    components: { ATextarea },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          name:[baseRules.requiredChange],
          appId:[baseRules.requiredChange],
          appSecret:[baseRules.requiredChange],
          token:[baseRules.requiredChange],
          pageUrl:[baseRules.requiredChange],
          // templateId:[baseRules.requiredChange],
          // title:[baseRules.requiredChange],
          // remark:[baseRules.requiredChange],
          // titleKw:[baseRules.requiredChange],
          // remarkKw:[baseRules.requiredChange],
          // nameKw:[baseRules.requiredChange],
          // periodDateKw:[baseRules.requiredChange],
          // periodFormKw:[baseRules.requiredChange],
        },
        confirmLoading: false,
        isView:false,
        url: {
          add: "/management/wechatConfig/add",
          edit: "/management/wechatConfig/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({
          titleKw:'first',
          remarkKw:'remark',
          nameKw:'keyword1',
          periodDateKw:'keyword2',
          periodFormKw:'keyword3',
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      view (record) {
        this.isView = true
        this.edit(record)
      },
      close () {
        this.$emit('close');
        this.isView = false
        this.visible = false;
      },
      handleOk () {
        if(this.isView){
          return
        }
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>